<script setup lang="ts">
import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'hexagon', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const sideLength = computed({
	get: () => dimensions.value.side_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "side_length",
			value: value,
		});
	},
});

document.addEventListener('focusin', (event) =>
	store.commit('updateFocusedElement', event)
);

onBeforeUnmount(() => {
	document.removeEventListener('focusin', () =>
		store.commit('updateFocusedElement')
	);
});

</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="hexagon-side_length"
			:id="`${prefix}measurements-hexagon-side_length`"
			:name="`${prefix}measurements[dimensions][side_length]`"
			unit="cm"
			:label="dimensionLabel('side_length', 'hexagon')"
			:instructions="isCutout ? '' : dimensionMaxLabel('side_length')"
			:invalid="!isDimensionValid(`${prefix}hexagon-side_length`)"
			:onBlur="() => addSizeToDataLayer('side_length', +sideLength, 'hexagon')"
			v-model="sideLength"
		/>
	</shape-input-fields-wrapper>
</template>
